<template>
  <div class="h-auto w-full mr-3 my-3">
    <div class="bg-white mx-3 rounded-b-md">
      <transition name="fade">
        <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
          <loader class="center-h-v" />
        </div>
      </transition>
      <div class="flex justify-between p-2">
        <el-pagination
          background
          @size-change="handleSizeChange"
          :page-sizes="pageSizes"
          :page-index="pageIndex"
          :page-size="pageSize"
          layout="sizes"
          :total="currentTableData.length"
        ></el-pagination>

        <!-- search -->
        <input
          v-model="searchInput"
          type="search"
          placeholder="Start typing to search..."
          class="bg-gray-200 w-52 py-1 rounded-md"
        />
        <!-- search -->
        <div class="flex flex-wrap justify-end w-full gap-3">
          <button
            @click="showCreateStrategicGoal = true"
            class="border-1.5 rounded-full px-2 py-1 items-center gap-1 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex capitalize"
          >
            <svg
              id="Layer_1"
              height="20"
              viewBox="0 0 24 24"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              fill="#fff"
            >
              <path
                d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
              ></path>
            </svg>
            Create
          </button>
        </div>
      </div>
      <div>
        <ve-table
          v-if="searchInput"
          :columns="columns"
          :table-data="filteredTableData"
          sort-order="asc"
        />

        <ve-table
          :columns="columns"
          :tableData="currentTableData"
          v-if="!searchInput.length"
        >
        </ve-table>

        <p
          v-if="searchInput.length && filteredTableData.length === 0"
          class="text-center py-3"
        >
          No results
        </p>

        <div
          v-if="tableData.length == 0 && !loading && !get_error"
          class="p-1 text-center text-sm w-full bg-gray-100"
        >
          <el-empty
            :image-size="70"
            description=" No strategic goals found"
          ></el-empty>
        </div>
        <!-- Pagination -->
        <div class="table-pagination text-center mt-2">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="totalCount"
            :page-size="pageSize"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
        <!-- Pagination -->
      </div>
    </div>

    <CreateStrategicGoal
      @close="showCreateStrategicGoal = false"
      @closeOnSuccess="handleCloseOnSuccess"
      :showCreateStrategicGoal="showCreateStrategicGoal"
      :reload="reload"
      :StrategicGoals="StrategicGoals"
    >
    </CreateStrategicGoal>

    <!-- edit -->
    <EditStrategicGoal
      @close="handleClose"
      :info="strategicGoalToEdit"
      :showEditStrategicGoal="showEditStrategicGoal"
      :StrategicGoals="StrategicGoals"
      :reviewPeriods="reviewPeriods"
      :reload="reload"
    >
    </EditStrategicGoal>

    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
  </div>
</template>

<script>
//import { utils, writeFileXLSX } from "xlsx";
import { importTemplateGenerator } from "@/utils/importTemplateGenerator";
import axios from "axios";

import Loader from "@/components/loader/loader.vue";
import ActionWarning from "@/utils/actionWarning.vue";
import { mapGetters } from "vuex";

export default {
  name: "reviewPeriodsList",
  components: {
    Loader,

    ActionWarning,
    EditStrategicGoal: () => import("./EditStrategicGoal.vue"),
    CreateStrategicGoal: () => import("./CreateStrategicGoal.vue"),
  },

  data() {
    return {
      url: "",
      title: "Review Periods List",

      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      StrategicGoals: [],
      reviewPeriods: [],
      resultColumns: [],

      showEditStrategicGoal: false,
      showCreateStrategicGoal: false,

      loading: false,
      get_error: null,
      create_success: null,
      del_document: null,
      del_error: null,
      info: null,
      message: null,

      searchInput: "",
      showActions: false,
      goalToDelete: null,
      showWarning: false,
      strategicGoalToEdit: {},
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        {
          field: "Name",
          key: "name",
          title: "Name",
          sampleValue: "2024 Jan-July",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <div class="flex gap-5 items-center">
              <p class="text-blue-500 cursor-pointer">{row.Name}</p>
            </div>
          ),
        },
        {
          field: "ReviewPeriod",
          key: "ReviewPeriod",
          title: "Review Period",
          sampleValue: "2024 Jan-July",
          headerAlign: "left",
          align: "left",
        },
        // {
        //   field: "Weight",
        //   key: "ExpectedWeight",
        //   title: "Expected Weight",
        //   sampleValue: "2024 Jan-July",
        //   headerAlign: "center",
        //   align: "center",
        //   renderBodyCell: ({ row }) => {
        //     const percentageFormatter = new Intl.NumberFormat("en-US", {
        //       style: "percent",
        //       minimumFractionDigits: 2,
        //       maximumFractionDigits: 2,
        //     });

        //     return percentageFormatter.format(row.Weight / 100);
        //   },
        // },
        {
          field: "Description",
          key: "Description",
          title: "Description",
          sampleValue: "2024 Jan-July",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <div class="flex gap-5 items-center">
              <p class="cursor-pointer">{row.Description}</p>
            </div>
          ),
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        const data = this.tableData;
        return data.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;

      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },

    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getStrategicGoals();
    this.getPerformancePeriods();
    this.setPageSizes();
  },
  methods: {
    setTab() {
      this.getStrategicGoals();
    },
    reload() {
      this.getStrategicGoals();
      this.showEditStrategicGoal = false;
      this.showCreateStrategicGoal = false;

      setTimeout(() => {
        this.showAssetBulkUpload = false;
      }, 3000);
    },
    showBulkUploadCallback() {
      this.showBulkUpload = false;
    },
    close() {
      this.showBulkUpload = false;
      this.$emit("close");
    },
    showBulkUploadForm() {
      this.resultColumns = this.columns.filter((col) => col.title !== "Action");
      this.showBulkUpload = true;
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleEditButtonClick(goal) {
      console.log(goal);
      this.strategicGoalToEdit = goal;
      this.showEditStrategicGoal = true;
    },
    handleDeleteButtonClick(goal) {
      // Handle the button click for the delete button
      //console.log(goal)
      this.title = `Delete ${goal.Name}`;
      this.message = `You are about to delete ${goal.Name} from the goals list!`;
      this.goalToDelete = goal;
      //console.log(this.goalToDelete)
      this.showWarning = true;
    },
    setIsConfirmed() {
      this.showWarning = false;
      if (this.goalToDelete) {
        this.deleteGoal(this.goalToDelete);
        return;
      }
    },
    exportTemplate() {
      this.filteredTabs = this.columns.filter(
        (column) => column.title !== "Action"
      );
      importTemplateGenerator(
        this.filteredTabs,

        "Strategic Goal List"
      );
    },
    handleClose() {
      this.showCreateStrategicGoal = false;
      this.showEditStrategicGoal = false;
    },
    handleCloseOnSuccess() {
      this.showCreateStrategicGoal = false;
      this.showLocCrSuccess = true;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getStrategicGoals();
    },

    handleDeleteOnSuccess() {
      setTimeout(() => {
        this.showLocDelSuccess = null;
      }, 3000);
      this.getStrategicGoals();
    },

    Adddocument(row) {
      this.selectedRow = row;
      this.showAdddocument = true;
    },

    handleCloseOnAddDept() {
      this.showAdddocument = false;
      this.showAdddocumentSuccess = true;
      setTimeout(() => {
        this.showAdddocumentSuccess = false;
      }, 3000);
    },

    // /{organization}/performance/strategic/goal/v1/request
    getStrategicGoals() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/strategic/goal/${this.$ApiVersion}/request`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.StrategicGoals = response.data.Data;
            this.tableData = this.StrategicGoals;
          } else {
            this.get_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loading = false;
          this.get_error = error.message;
        }
      );
    },

    // performance/period/v1/request
    getPerformancePeriods() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/period/${this.$ApiVersion}/request`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            //console.log(response.data.Data);
            this.reviewPeriods = response.data.Data;
          } else {
            this.$notify.error({
              title: "Failure",
              message: response.StatusMessage,
            });
          }
        },
        (error) => {
          this.loading = false;
          this.$notify.error({ title: "Failure", message: error.message });
        }
      );
    },

    deleteGoal(row) {
      // /{organization}/performance/strategic/goal/v1/delete
      let url = `${this.getOrganization}/performance/strategic/goal/${this.$ApiVersion}/delete`;

      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        data: {
          StrategicGoalId: row.Id,
        },
      };
      axios
        .delete(
          url,

          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.showLocDelSuccess = response.data.StatusMessage;
              this.handleDeleteOnSuccess();
              // this.getStrategicGoals()
            } else {
              this.del_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
          }
        );
    },
  },
};
</script>
<style>
.ve-table-body-td {
  z-index: -2;
}
</style>
